import { render, staticRenderFns } from "./appHeader.vue?vue&type=template&id=b486c84a&scoped=true"
import script from "./appHeader.vue?vue&type=script&lang=js"
export * from "./appHeader.vue?vue&type=script&lang=js"
import style0 from "./appHeader.vue?vue&type=style&index=0&id=b486c84a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b486c84a",
  null
  
)

export default component.exports